import moment from 'moment'
import axios from 'axios'
import swal from 'sweetalert2'
export default {
  data: () => {
    return {
      publicPath: 'https://plugin.zwiz.ai/v1.2/chat/'
      // publicPath: '../'
    }
  },
  methods: {
    publicUrl(url) {
      return `${this.publicPath}${url}?not-from-cache-please`
    },
    isURL: function (str) {
      var pattern = new RegExp(
        // eslint-disable-next-line no-useless-escape
        /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
      ) // fragment locator
      return pattern.test(str)
    },
    async chatlog(userid, pageid) {
      try {
        const response = await axios.get(
          `${this.$store.getters.setting.serverUrl}warroom/webchat/chatlog`,
          {
            headers: {
              AUTHORIZATION: this.$store.getters.setting.accessToken // "1357f80e8330b64ae40702kosumida25"
            },
            params: {
              userid: userid,
              pageid: pageid || this.$store.getters.setting.pageid,
              offset: 0,
              limit: 15
            }
          }
        )
        if (response.data.responsecode == 200) {
          localStorage.setItem('chatlog', JSON.stringify(response.data.data))
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async pushMessage(userid, pageid, message, onSendQuestionMessage) {
      const data = {
        pageid: pageid,
        userid: userid,
        message: { data: message.payload.trim(), type: message.type || 'text' }
      }
      const setting = this.$store.getters.setting
      let questionMessage = {
        actor: 'question',
        type: message.type || 'text',
        text: message.title,
        timestamp: moment().format('YYYY-MM-DD HH:mm')
      }
      if (questionMessage.type == 'image') {
        questionMessage.image_url = message.payload.trim()
      }
      if (onSendQuestionMessage) onSendQuestionMessage(questionMessage)
      const url = setting.hasWarroom ? `warroom/webchat/webhook` : `webhookwebchat`
      const response = await axios.post(`${setting.serverUrl}${url}`, data, {
        headers: {
          Authorization: setting.accessToken
        }
      })
      if (response.data.responsecode == 200) {
        if (response.data.data && response.data.data.length) {
          return {
            question: questionMessage,
            messages: response.data.data || [],
            quick_replies: response.data.quick_replies ? response.data.quick_replies.split(',') : ''
          }
        } else {
          null
        }
      } else {
        swal.fire({
          icon: 'error',
          title: response.data.reason || 'Error',
          text: response.data.responsecode
        })
      }
    }
  }
}
